// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { AllergyRequest } from './allergy-request';

/** See com.rev360.pms.api.controller.person.CreateDrugAllergyRequest */
/* istanbul ignore next */
@GandalfModel
export class CreateDrugAllergyRequest extends AllergyRequest {

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	deactivationDate!: Date | null;

	@GandalfValidator({ sizeString: { message: 'Description cannot be longer than 4000 characters', minLength: 0, maxLength: 4000 } })
	@GandalfProperty({ designType: String })
	description!: string | null;

	@GandalfProperty({ designType: Number })
	drugClassId!: number | null;

	@GandalfProperty({ designType: Number })
	drugId!: number | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	endDate!: Date | null;

	@GandalfValidator({ sizeString: { message: 'External ID cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	externalId!: string | null;

	@GandalfValidator({ notNull: { message: 'Patient Id is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	patientId!: number;

	@GandalfArray(Number)
	reactionIds!: number[] | null;

	@GandalfConstantDecorator(constants.AllergySeverity)
	@GandalfValidator({ notNull: { message: 'Severity is required' } })
	@GandalfProperty({ designType: constants.AllergySeverity, isRequired: true })
	severity!: constants.AllergySeverity;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	startDate!: Date | null;

	@GandalfConstantDecorator(constants.AllergyStatus)
	@GandalfProperty({ designType: constants.AllergyStatus })
	status!: constants.AllergyStatus | null;

	@GandalfValidator({ sizeString: { message: 'Treatment cannot be longer than 4000 characters', minLength: 0, maxLength: 4000 } })
	@GandalfProperty({ designType: String })
	treatment!: string | null;

}
